import React from "react";
import { Stack, Typography } from "@mui/material";

import WorkOrderLabel from "./WorkOrderLabel";
import { StyledBaseBox } from "./styles";
import { formatDateMmDdYyyy } from "../../helpers/dateHelper";
import { getDollarValue } from "../../helpers/currency";
import { getWorkOrderInstructions } from "./helper";

const WorkOrderDetails = ({ data }) => {
  const wax = getWorkOrderInstructions(data, 1);
  return (
    <StyledBaseBox
      sx={{ gridAutoRows: "17px", alignItems: "center", justifyItems: "start" }}
      customColumns="300px 1fr 1fr"
    >
      <Stack
        alignItems="start"
        justifySelf="start"
        gridColumn="span 1"
        gridRow="span 3"
        maxWidth="250px"
      >
        <Typography
          variant="barcode"
          sx={{
            transform: "scaleX(0.65)",
            transformOrigin: "center left",
            textWrap: "nowrap",
          }}
        >
          *{data?.workOrder}*
        </Typography>
        <Typography variant="caption" mx="auto">
          {data?.workOrder}
        </Typography>
      </Stack>
      <WorkOrderLabel label="PO #" value={data?.order?.poNumber} />
      <WorkOrderLabel label="Company" value={data?.customer?.name} />

      {/* <div /> */}
      {/* Score is unitless, represents WO value (line item value / # work orders) / 1000 */}
      <WorkOrderLabel label="SCORE" value={data?.price} />
      <WorkOrderLabel
        label="SALES ORDER #"
        value={data?.lineItem?.lineNumber}
      />
      {/* <div /> */}

      <WorkOrderLabel label="TOTAL LINE QTY" value={data?.lineItem?.quantity} />
      <WorkOrderLabel label="MOLD #" value={wax?.config?.moldNumber} />
      {/* <div /> */}

      <WorkOrderLabel
        label="REC DATE"
        value={formatDateMmDdYyyy(data?.createdAt)}
        c1="100px"
        valueBold
      />
      <WorkOrderLabel label="QUANTITY REQ" value={data?.quantityReq} />
      <WorkOrderLabel label="PART NO." value={data?.part?.partNumber} />
      {/* <div /> */}

      <WorkOrderLabel
        label="DUE DATE"
        value={formatDateMmDdYyyy(data?.lineItem?.dueDate)}
        c1="100px"
        valueBold
      />
      <WorkOrderLabel label="PAT. REQ" value={data?.quantity} />
      <WorkOrderLabel label="PART NAME" value={data?.part?.partName} />
      {/* <div /> */}
    </StyledBaseBox>
  );
};

export default WorkOrderDetails;
